import Logo from "@/User/Assets/Images/logo.webp";
import InfoButton from "@/User/Components/Buttons/InfoButton";
import WhiteButton from "@/User/Components/Buttons/WhiteButton";
import MenuMobile from "@/User/Components/Header/MenuMobile";
import MenuPC from "@/User/Components/Header/MenuPC";
import { APP_HEADER_ID, HEADER_ID } from "@/User/Constants/elements";
import { RouteName } from "@/User/Constants/routes";
import { ANDROID_APP_URL, ANDROID_REDIRECT_URI, IOS_APP_URL, IOS_REDIRECT_URI } from "@/Utils/MobileAppUtils";
import { getMenuData } from "@/Utils/UserAppUtils";
import { detectDevice } from "@/utils";
import { usePage } from '@inertiajs/react';
import React, { useEffect, useState } from 'react';
import route from 'ziggy-js';
import PrimaryButton from "../Buttons/PrimaryButton";

const Header = ({ showAuthButton = true, showAppHeader = true }) => {
    const { isMobile, isIOS } = detectDevice();
    const { auth: { user } } = usePage().props;
    const [headerMenu, setHeaderMenu] = useState(getMenuData({ user: user?.data }));

    const handleMouseEnterMenu = (target) => () => {
        headerMenu[target].isActive = true;
        setHeaderMenu({ ...headerMenu });
    };

    const handleMouseLeaveMenu = (target) => () => {
        headerMenu[target].isActive = false;
        setHeaderMenu({ ...headerMenu });
    };

    const toggleMenu = (target) => () => {
        if (headerMenu[target].isActive) {
            handleMouseLeaveMenu(target)();
        } else {
            handleMouseEnterMenu(target)();
        }
    };

    useEffect(() => {
        setHeaderMenu({ ...getMenuData({ user: user?.data }) });
    }, [user]);

    return (
        <>
            {isMobile && showAppHeader && (
                <div id={APP_HEADER_ID} className="px-4 py-1.5 md:px-8 lg:hidden bg-alice-blue-4 flex items-center justify-between border-b border-b-pattens-blue">
                    <div className="flex flex-col gap-0">
                        <p className="text-primary font-bold leading-5">リラパスアプリ</p>
                        <span className="text-xs font-feature-palt-on">独立・起業のためのスカウトアプリ</span>
                    </div>
                    <div className="flex gap-2 flex-col xs:flex-row">
                        <WhiteButton className="!text-xss !px-4 !py-2"
                            as="link" href={isIOS ? IOS_REDIRECT_URI : ANDROID_REDIRECT_URI}
                            isShadow={true}
                            isRounded={true}
                        >
                            開く
                        </WhiteButton>
                        <InfoButton className="!text-xss !px-4 !py-2" as="link" href={isIOS ? IOS_APP_URL : ANDROID_APP_URL} isShadow={true}
                            isRounded={true}>インストール</InfoButton>
                    </div>
                </div>
            )}

            <header id={HEADER_ID} className={`sticky top-0 bg-white border-b border-iron shadow-base shadow-black/10 z-999`}>
                <div
                    className={`lg:px-0 lg:container flex items-center justify-between ${showAuthButton && user ? "py-0 pl-4 md:pl-8" : "py-2 px-4 md:px-8"}`}>
                    <a href={route(RouteName.IndexPage)}>
                        <picture>
                            <source srcSet={Logo} className="max-w-full w-22.25 h-27px lg:w-36 lg:h-11" alt="リラパスアプリ" />
                            <img src={Logo} className="max-w-full w-22.25 h-27px lg:w-36 lg:h-11" alt="リラパスアプリ" />
                        </picture>
                    </a>
                    {showAuthButton && (
                        <>
                            {user ? (
                                <>
                                    <MenuPC
                                        className="hidden lg:flex"
                                        headerMenu={headerMenu}
                                        handleMouseEnterMenu={handleMouseEnterMenu}
                                        handleMouseLeaveMenu={handleMouseLeaveMenu}
                                    />
                                    <MenuMobile
                                        className="flex lg:hidden"
                                        headerMenu={headerMenu}
                                        toggleMenu={toggleMenu}
                                    />
                                </>
                            ) : (
                                <div className="flex gap-2">
                                    <PrimaryButton as="link" href={route(RouteName.LoginPage)} isOutline={true}
                                        isRounded={true}>
                                        ログイン
                                    </PrimaryButton>
                                    <PrimaryButton as="link" href={route(RouteName.RegistrationPage)} isRounded={true}>
                                        会員登録
                                    </PrimaryButton>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </header>
        </>
    );
};

export default Header;
